import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "";
var Styles = {};
styleInject(css_248z);

export { Styles as default };
//# sourceMappingURL=InfoPopup.module.scss.js.map
